import { render, staticRenderFns } from "./tan_file_type.vue?vue&type=template&id=354d9ec2&scoped=true"
import script from "./tan_file_type.vue?vue&type=script&lang=js"
export * from "./tan_file_type.vue?vue&type=script&lang=js"
import style0 from "./tan_file_type.vue?vue&type=style&index=0&id=354d9ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d9ec2",
  null
  
)

export default component.exports